export enum EDataStatus {
  GREEN,
  ORANGE,
  RED,
  GRAY,
}
